import Script from 'next/script';
import { ValidatedScripts } from '../response-data-validator';
interface Props {
  mediaadData: ValidatedScripts['mediaad'];
}
export const MediaadScript = ({
  mediaadData
}: Props) => {
  if (!mediaadData?.enabled) return null;
  return <Script defer strategy='lazyOnload' crossOrigin='anonymous' type='text/javascript' src='https://s1.mediaad.org/serve/14752/retargeting.js' data-sentry-element="Script" data-sentry-component="MediaadScript" data-sentry-source-file="mediaad.tsx" />;
};